<template>
  <div>
    <div class="container">
      <el-breadcrumb class="hsb-breadcrumb" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>机况评估</el-breadcrumb-item>
      </el-breadcrumb>
      <div>
        <div class="fr hidden-xs product-info-wrapper">
          <product-info class="bg-white" :pic="params.pic" :product-name="params.productName" :show-btn="false">
            <div class="pi clearfix center-block mb-lg">
              <div class="fl">
                <span>{{ params.maxPrice | fen2yuan }}</span>
                <p class="text-muted mt-xs">最高回收价</p>
              </div>
              <div class="split"></div>
              <div class="fr">
                <span>{{ recycleNum }}</span>
                <p class="text-muted mt-xs">已成功收钱</p>
              </div>
            </div>
            <h-button class="center-block text-sz-sec-title mb-lg" style="width: 197px" type="primary" :disabled="!isCompleted || !loaded" :loading="loading" size="large" @click="submit(true)">
                {{ $t('evaluate.submit') }}
            </h-button>
            <h-button @click="reselect" class="text-primary" type="text">重新选择机型</h-button>
          </product-info>
          <div class="recyle-tip bg-white">
            <h3>回收须知</h3>
            <div class="hsb-hr"></div>
            <p>1.山寨机，高仿机不回收。</p>
            <p>2.屏幕锁未解，iCloud账户未注销不回收。</p>
            <p class="tip">拒收并退回以上两种手机，您需承担双向运费。</p>
            <a target="_blank" href="//www.huishoubao.com/banner-deblock?pid=1004" class="how-to-fix">
              <span>如何解锁</span>
              <img src="//s1.huishoubao.com/static/pc/1001/img/logo-question.png">
            </a>
          </div>
        </div>
        <tip class="visible-xs-block"></tip>
        <div class="visible-xs-block xs-product-name text-center bg-white">
          评估机型：{{ params.productName }}
        </div>
        <div class="left">
          <hr class="hr visible-xs-block">
          <Evaluate ref="evaluate" v-model="selects" show-selected-info auto-flod :group="true"/>
        </div>
      </div>
      <div class="bg-white e-ft visible-xs-block mt-lg footer-fiexed">
        <h-button class="btn-lg" type="primary" :disabled="!isCompleted || !loaded" :loading="loading" size="large" @click="submit(true)">
            {{ $t('evaluate.submit') }}
        </h-button>
      </div>
      <evalModal></evalModal>
    </div>
  </div>
</template>

<script type="text/javascript">
import productParam from '@/core/evaluate/store.js';
import EvaluateCore from '@/core/evaluate/index.vue';
import Tip from '../../components/ev-tip/index';
import evalModal from './eval-modal';
import { Breadcrumb, BreadcrumbItem } from 'element-ui';

export default {
  tname: 'product',
  asyncData ({ store, route }) {
    return store.dispatch('productParam/get', route.params.productId);
  },
  registerModule (store, preserveState) {
    store.registerModule('productParam', productParam, { preserveState });
  },
  destroyed () {
    this.$store.unregisterModule('productParam');
  },
  extends: EvaluateCore,
  components: {
    Tip,
    evalModal,
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem
  }
};
</script>

<style lang="postcss" scoped>

@import 'config.css';

.product-info-wrapper {
  width: 330px;
  /deep/ .product-info {
    padding-top: 16px;
  }
  /deep/ .img-responsive {
    width: 150px;
  }
}

.left {
  width: 850px;
  margin-right: 350px;
  /*padding: 23px 37px;*/
}

.e-ft {
  padding: 16px 20px;
}

.btn-lg {
  height: 38px;
}

.pi {
  width: 210px;
  position: relative;
}

.split {
  position: absolute;
  width: 1px;
  height: 36px;
  background-color: #EDEDED;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

/deep/ .clearfix:after {
  clear: left;
}

@media (--not-sm-viewport) {
  /deep/ .hr {
    margin: 26px 0;
  }

  .left /deep/ .answer-item:nth-child(2n-1) {
    width: 48.5%;
    margin-right: 3%;
  }

  .container {
    margin-bottom: 50px;
  }
}

@media (--sm-viewport) {

  .hsb-button--large {
    width: 100%;
  }

  .left {
    width: 100%;
    padding: 1px 20px 16px;
  }

  .left /deep/ .answer-item {
    height: 40px;
  }

  .xs-product-name {
    padding: 19px 0 4px;
    font-size: 16px;
  }

  .hr {
    margin-bottom: 16px;
  }

}

.recyle-tip {
  color: #666;
  text-align: center;
  margin-top: 15px;
  padding-bottom: 30px;
  line-height: 1.8;
  h3 {
    text-align: center;
    font-size: 16px;
    color: #999999;
    padding-top: 15px;
    padding-bottom: 15px;
    font-weight: 400;
  }
  .hsb-hr {
    border-bottom: 1px #f5f5f5 solid;
    width: 100%;
    margin-bottom: 28px;
  }
  .tip {
    color: #babcc2;
    margin-top: 40px;
  }
  .how-to-fix {
    img {
      vertical-align: middle;
    }
  }
}

.left {
  /deep/ .base-items {
    padding: 23px 37px;
    background-color: #fff;
    padding-bottom: 20px;
    margin-bottom: 20px;
  }
  /deep/ .hr {

  }
  /deep/ .base-item {
    /*overflow: hidden;*/
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/productInfo/index.vue